import script from "./SetShop.vue?vue&type=script&lang=ts&setup=true"
export * from "./SetShop.vue?vue&type=script&lang=ts&setup=true"

import "./SetShop.vue?vue&type=style&index=0&id=24091fb0&lang=scss"

const __exports__ = script;

export default __exports__